import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../DialogResult";
import { Observable } from "rxjs";

export interface HtmlMessageDialogData {
  title: string;
  htmlPrompt: string;
}

@Component({
  selector: "html-message-dialog",
  templateUrl: "./html-message-dialog.component.html",
})
export class HtmlMessageDialogComponent {
  public Result: DialogResult;

  constructor(
    public dialogRef: MatDialogRef<HtmlMessageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: HtmlMessageDialogData
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.dialogRef.close(this.Result);
  }

  static showDialog(
    dialog: MatDialog,
    title: string,
    htmlPrompt: string
  ): Observable<any> {
    var params: HtmlMessageDialogData = {
      title: title,
      htmlPrompt: htmlPrompt,
    };

    var dialogRef = dialog.open(HtmlMessageDialogComponent, {
      disableClose: true,
      width: "500px",
      data: params,
    });

    return dialogRef.afterClosed();
  }
}
